import { appEnv } from '@/lib/firebase';

/** Selo visível fora de produção (ex.: HOMOLOGAÇÃO), para não confundir os ambientes. */
export function EnvBadge({ className = '' }: { className?: string }) {
  if (appEnv !== 'hml') return null;
  return (
    <span
      role="status"
      className={`inline-flex items-center rounded-full bg-[var(--taskall-status-warning,#b45309)] px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-white ${className}`}
    >
      Homologação
    </span>
  );
}
